import {UyapRequest} from "./UyapRequest";
import {ISorguSonuc} from "./CommonInterfaces";
import app from "@/main";

export interface BorcluSgkHacizTalep {
    dosyaId: string|number,
    kisiKurumId: number
}

export interface BorcluSgkHacizCevap extends ISorguSonuc<Array<ISgkHacizSonuc>>{
}

export interface ISgkHacizSonuc{
    kisiTipString: string,
    show: boolean,
    selected?: boolean
}

export default class BorcluSgkHaciz extends UyapRequest<BorcluSgkHacizTalep, BorcluSgkHacizCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Borçlu SGK haciz bilgileri sorgulanıyor...";
    }

    /**
     * Snapshot deposundaki alan adı (picker `name`). Okuma zincirine de girer. NOT: bu sınıf hem `sgkhaciz` hem
     * `sgkMossip` üyesini dolduruyor (aynı istek, aynı gövde, aynı cache
     * anahtarı); depodaki karşılığı `sgkhaciz` satırıdır.
     */
    protected snapshotAlani(): string | null {
        return "sgkhaciz";
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "borcluSgkHaciz_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        // var
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","yabanci":false,"mavikart":false,"sorguTuru":0,"tcKimlikNo":"1********72","adi":"AB********* ON**","soyadi":"AL******","babaAdi":"O****","anaAdi":"S****","dogumTarihiStr":"1981","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":86947566,"turu":0},"sorgulayanBilgileri":"Av.FATMA YAŞAR SEZER","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 8. Genel İcra Dairesi","birimId":"1000939","orgKodu":"1.04.011.000.6043","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6043","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/126218","dosyaNoYil":2023,"dosyaSira":126218,"dosyaId":"h3LUblddhScyviEq7WzZMXR5rsIUss+4z6Kx8olPV70wPOtgClhczMEyAESaZvIM","dosyaAcilisTarihi":"03/12/2023 17:49","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ÖZAYLAR EL ALETLERİ HIRDAVAT İNŞAAT TİCARET VE SANAYİ ANONİM ŞİRKETİ, ABDURRAHMAN ONUR ALBAYRAK, PARİBU KRİPTO VARLIK ALIM SATIM PLATFORMU ANONİM ŞİRKETİ, PAPARA ELEKTRONİK PARA ANONİM ŞİRKETİ, BTCTURK KRİPTO VARLIK ALIM SATIM PLATFORMU ANONİM ŞİRKETİ, QNB BANK ANONİM ŞİRKETİ, PORT KARGO VE LOJİSTİK ANONİM ŞİRKETİ, HAMDİ ATASOY","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"14/10/2025 11:02","sorguSonucDVO":[{"kisiTipString":"Bağ-Kur Sigortalı Aktif","show":true},{"kisiTipString":"GSS Sigortalısı (Gerçek)","show":false},{"kisiTipString":"Diğer - Gerçek","show":false}],"sorgulamaTuru":"SGK HACİZ","sorguSonucu":true,"hasError":false,"hasData":true,"isMock":false};
    }


    getUrl(): string {
        return this.ImzaClientAddr + "borclu_bilgileri_goruntule_sgk_haciz.ajx";
    }

    async parse(data: any): Promise<BorcluSgkHacizCevap>{
        data.message = "SGK kaydı " + (data.sorguSonucu ? 'var' : 'yok');

        // Sadece show: true olanları filtrele ve selected property'si ekle
        if (data.sorguSonucDVO && Array.isArray(data.sorguSonucDVO)) {
            data.sorguSonucDVO = data.sorguSonucDVO
                .filter((item: ISgkHacizSonuc) => item.show)
                .map((item: ISgkHacizSonuc) => ({
                    ...item,
                    selected: true
                }));
        }

        return data;
    }
}

